import { t, useBehaviorSubject } from '@base/utils/helpers';
import styles from '../styles/gameMenu.module.scss';
import React, { useEffect, useState } from 'react';
import GameMenuModal from './gameMenuModal';
import abort from '../assets/abort.svg';
import resign from '../assets/resign.svg';
import mail from '../assets/mail.svg';
import autoroll_off from '../assets/autoroll_off.svg';
import autoroll_on from '../assets/autoroll_on.svg';
import GameModalContent from '../constants/constants';
import { container } from 'tsyringe';
import preferences_icon from '../assets/cog.svg';
import { IPreferencesService } from '@base/features/preferences/model/types';
import { Preferences } from '@backgammon/constants/defaultPreferences';
import { IModalProvider } from '@base/features/modal/model/interfaces';
import preferencesModal from '@base/features/preferences/components/preferencesModal';
import { BaseGameState, IGameProvider } from '@base/features/game/model/interfaces';

export default function GameMenu(props: { gameState: BaseGameState }) {
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const [showModal, setShowModal] = useState<GameModalContent | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const inProgress = useBehaviorSubject(props.gameState.gameInProgress);
  // const takeBackOffered = useSubject(props.gameState.onTakeBackOffered);
  const preferencesService: IPreferencesService<Preferences> = container.resolve('preferencesService');
  const preferences = useBehaviorSubject(preferencesService.onPreferencesChanged);
  const gameProvider: IGameProvider = container.resolve('gameProvider');

  useEffect(() => {
    // setIsPlaying(Boolean(inProgress && props.gameState.imPlaying() && !takeBackOffered));
    setIsPlaying(Boolean(inProgress && props.gameState.imPlaying()));
  }, [props.gameState, inProgress]);

  const buttons = [
    {
      title: t('preferences'),
      onClick: () => modalProvider.show(preferencesModal()),
      icon: preferences_icon,
      alwaysActive: true,
    },
    {
      title: t('resign'),
      onClick: () => setShowModal(GameModalContent.RESIGN),
      icon: resign,
    },
    {
      title: t('abort'),
      onClick: () => setShowModal(GameModalContent.ABORT_GAME),
      icon: abort,
    },
    {
      title: t('email_game'),
      onClick: () => setShowModal(GameModalContent.EMAIL_GAME),
      icon: mail,
    },
  ];

  const autoRollButton = {
    title: `${t('auto_roll')}: ${t(preferences.AUTO_ROLL ? t('on') : t('off'))}`,
    onClick: () => preferencesService.updatePreferences('AUTO_ROLL', !preferences.AUTO_ROLL),
    icon: preferences.AUTO_ROLL ? autoroll_on : autoroll_off,
    alwaysActive: true,
  };

  // Add auto roll for backgammon
  if (gameProvider.GAME_ID === 5) {
    buttons.splice(2, 0, autoRollButton);
  }

  return (
    <div className={styles.container}>
      <button
        className={styles.menuBtn}
        style={{ maxWidth: 'initial', paddingLeft: '1rem' }}
        onClick={() => setShowModal(GameModalContent.CLOSE_TABLE)}
      >
        <span className={styles.title}>{t('exit')}</span>
      </button>
      {buttons.map((button) => (
        <button
          className={styles.menuBtn}
          key={button.title}
          onClick={button.onClick}
          style={{
            visibility: button.alwaysActive || isPlaying ? 'visible' : 'hidden',
          }}
        >
          <div className={styles.icon} style={{ backgroundImage: `url(${button.icon})` }} />
          <span className={styles.title}>{button.title}</span>
        </button>
      ))}
      {showModal && (
        <GameMenuModal
          content={showModal}
          closeModal={() => setShowModal(null)}
          gameState={props.gameState}
        />
      )}
    </div>
  );
}
